import React, { useState, useEffect } from 'react'
import { Box, HStack, IconButton, Text } from '@chakra-ui/react'
import { Icon } from '.'

const Pagination = ({ onChange, pageSpan, pageSize, total, showTotal=true, ...rest }) => {
        
    const LEFT_PAGE = 'LEFT';
    const RIGHT_PAGE = 'RIGHT';
    const [current, setCurrent] = useState(1)
    const [pages, setPages] = useState(0)
    const pageNeighbours = pageSpan || 2;

    const handleChange = (index) => {
        setCurrent(index)
        onChange(index, pageSize)
    }
    
    

    useEffect(() => {
        setPages(Math.ceil(total / pageSize));
        setCurrent(1)
    }, [total, pageSize])

    const range = (from, to, step = 1) => {
        let i = from;
        const range = [];

        while (i <= to) {
            range.push(i);
            i += step;
        }

        return range;
    }

    const handleMoveLeft = (e) => {
        e.preventDefault();
        // let jump = current - (pageNeighbours * 2) - 1;
        let jump = current - 1;
        handleChange(jump < 1 ? 1 : jump);
    }

    const handleMoveRight = (e) => {
        e.preventDefault();
        // handleChange(current + (pageNeighbours * 2) - 1);
        handleChange(current + 1);
    }

    const getPageNumbers = () => {
        const totalPages = pages;
        const currentPage = current;
        const totalNumbers = (pageNeighbours * 2) + 3;
        const totalBlocks = totalNumbers + 2;
        let all_pages = [];
        if (totalPages > totalBlocks) {
            const startPage = Math.max(2, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
            all_pages = range(startPage, endPage);
            const hasLeftSpill = startPage > 2;
            const hasRightSpill = (totalPages - endPage) > 1;
            const spillOffset = totalNumbers - (all_pages.length + 1);
            switch (true) {
                // handle: (1) < {5 6} [7] {8 9} (10)
                case (hasLeftSpill && !hasRightSpill): {
                    const extraPages = range(startPage - spillOffset, startPage - 1);
                    all_pages = [LEFT_PAGE, ...extraPages, ...all_pages];
                    break;
                }

                // handle: (1) {2 3} [4] {5 6} > (10)
                case (!hasLeftSpill && hasRightSpill): {
                    const extraPages = range(endPage + 1, endPage + spillOffset);
                    all_pages = [...all_pages, ...extraPages, RIGHT_PAGE];
                    break;
                }

                // handle: (1) < {4 5} [6] {7 8} > (10)
                case (hasLeftSpill && hasRightSpill):
                default: {
                    all_pages = [LEFT_PAGE, ...all_pages, RIGHT_PAGE];
                    break;
                }
            }
            all_pages = [1, ...all_pages, totalPages];
        } else {
            all_pages = range(1, totalPages);
        }


        let elements = []
        all_pages.map((page, index) => {
            if (page === LEFT_PAGE) {
                return elements.push(
                    <IconButton boxSize="28px" lineHeight="28px" p={0} key={index} onClick={handleMoveLeft} rounded="full" variant="subtle" colorScheme="gray" icon={<Icon color="currentcolor" size={7}  name="arrow-left-s-fill" />} />
                )
            }
            if (page === RIGHT_PAGE) {
                return elements.push(
                    <IconButton boxSize="28px" key={index} onClick={handleMoveRight} rounded="full" variant="subtle" colorScheme="gray" icon={<Icon color="currentcolor" size={7}  name="arrow-right-s-fill" />} />
                )
            }
            return elements.push(
                // <Button key={index} rounded="full" onClick={() => handleChange(page)} colorScheme={current === page ? 'brand' : 'gray'} px="8px" size="xs" d="block" variant={current === page ? "solid" : "ghost"}>{page}</Button>
                <Box
                    key={index}
                    rounded="full"
                    minW="28px"
                    h="28px"
                    px="6px"
                    textAlign="center"
                    lineHeight="28px"
                    whiteSpace="nowrap"
                    onClick={() => handleChange(page)}
                    cursor="pointer"
                    fontWeight="600"
                    fontSize="11px"
                    bg={current === page ?  "brand.100" : "gray.100"}
                    color={current === page ?  "brand.600" : "gray.600"}
                >{page}</Box>

            )

        })
        return elements;
    }
    if(pages > 1){
        return (
            <Box {...rest}>                
            <HStack spacing="8" alignItems="center">
                <HStack spacing="2" alignItems="center">
                    {getPageNumbers()}
                </HStack>

                {showTotal &&
                <Box px={2} py={1} borderWidth="1px" borderColor="gray.400" borderRadius="9999px">
                    <Text fontSize="sm" fontWeight="semibold">Total {total}</Text>
                </Box>
                }
            </HStack>
            </Box>
        )
    }else{
        return <></>
    }
}

export { Pagination }